<template lang="pug" src="./reason-requests-list.pug"> </template>
<style lang="scss" src="./reason-requests-list.scss" scoped> </style>

<script>

import { mapState } from 'vuex';

import removeDialog from './remove-dialog';
import editDialog from './edit-dialog';
import createDialog from './create-dialog';

export default {
    components: {
        'v-remove-dialog': removeDialog,
        'v-edit-dialog': editDialog,
        'v-create-dialog': createDialog
    },
    data: () => ({
        name: null,
        editDialog: false,
        removeReasonId: null,
        createDialog: false,
        editedReason: null,
        removeDialog: false
    }),
    computed: {
        ...mapState({
            reasons: state => state.photoReasons.reasons,
            pagination: state => state.photoReasons.pagination
        }),
        headers() {
            return ['#', 'name', 'photo', 'actions', 'createdAt'].map((it) => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.PhotoReport.reasonRequestsList.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        }
    },
    created: function() {
        this.loadReasons();
    },
    methods: {
        loadReasons(page = 1) {
            this.$store.dispatch('photoReasons/getReasons', { page, name: this.name });
        },

        reasonTypes(reason) {
            return reason.types.map(it => it.name).join(', ');
        },

        showEditDialog(reason) {
            this.editDialog = true;
            this.editedReason = JSON.parse(JSON.stringify(reason));
        },

        openRemoveDialog(id) {
            this.removeReasonId = id;
            this.removeDialog = true;
        },

        openCreateDialog() {
            this.createDialog = true;
        },

        async removeReason(removeReasonId) {
            await this.$store.dispatch('photoReasons/deleteReason', removeReasonId);
            
            if (this.pagination.page !== 1 && !this.reasons.length) {
                this.loadReasons(this.pagination.page - 1);
            }
        }
    }
};
</script>
